export var IdTooltipType;
(function (IdTooltipType) {
    IdTooltipType["BaseBuilding"] = "BaseBuilding";
    IdTooltipType["Outskirt"] = "Outskirt";
    IdTooltipType["Expansion"] = "Expansion";
})(IdTooltipType || (IdTooltipType = {}));



//////////////////
// WEBPACK FOOTER
// ./src/constants/IdTooltipType.ts
// module id = 572
// module chunks = 3